
export const Members = [
  {
    name: "Acquah (Dr. Fresh)",
    role: "Founder Tech Space",
    image: "/headShots/shot1.jpg",
  },
  {
    name: "Abigail Thelma Ojore",
    role: "Virtual Assistant",
    image: "/headShots/shot2.jpg",
  },
  {
    name: "Oni Temitayo ",
    role: "Full Stack Engineer",
    image: "/headShots/shot3.jpg",
  },
  {
    name: "Ajilore Bukunmi Faith ",
    role: "Graphic Designer",
    image: "/headShots/shot4.jpg",
  },
  {
    name: "Israel Sandra",
    role: "Frontend Developer",
    image: "/headShots/shot5.jpg",
  },
  {
    name: "Agu Gideon",
    role: "Frontend Developer",
    image: "/headShots/shot6.jpg",
  },
  {
    name: "Olorunfemi Favour Ayanfe",
    role: "Virtual Assistant",
    image: "/headShots/shot7.jpg",
  },
  {
    name: "Victor Ifeanyichukwu",
    role: "Frontend Engineer",
    image: "/headShots/shot8.jpg",
  },
  {
    name: "Adenrele Mariam Oyindamola",
    role: "Frontend Developer",
    image: "/headShots/shot9.jpg",
  },
  {
    name: "Temitope Bawa-Allah",
    role: "Backend Developer",
    image: "/headShots/shot10.jpg",
  },
  {
    name: "Evelyn Olagunju",
    role: "Product Manager",
    image: "/headShots/shot11.jpg",
  },
  {
    name: "Emmanuel Alex Edosa",
    role: "IT Support Specialist",
    image: "/headShots/shot12.jpg",
  },
  {
    name: "Ukeme Robinson",
    role: "Social Media Strategist",
    image: "/headShots/shot13.jpg",
  },
  {
    name: "Abinye Jaja",
    role: "Frontend Developer",
    image: "/headShots/shot14.jpg",
  },
  {
    name: "Chidimma Okey-Okoro",
    role: "UI / UX Designer",
    image: "/headShots/shot15.jpg",
  },
  {
    name: "Chizoba Opara",
    role: "Frontend Developer",
    image: "/headShots/shot16.jpg",
  },
  {
    name: "Omolaja Mamun",
    role: "Backend Developer",
    image: "/headShots/shot17.jpg",
  },
  {
    name: "Akinlola Bukola",
    role: "Data Analytics",
    image: "/headShots/shot18.jpg",
  },
  {
    name: "Deborah Utomi Chidinma",
    role: "Product Manager",
    image: "/headShots/shot19.jpg",
  },
  {
    name: "Christopher Stephen",
    role: "Fullstack Engineer",
    image: "/headShots/shot20.jpg",
  },
];
